<template>
  <v-layout wrap>
    <v-flex xs12>
      <p
        class="pl-2 text-xs-left mb-0 mt-3 body-2 grey--text text--darken-2"
        style="font-weight:600;"
      >Informações do contrato</p>
    </v-flex>

    <v-flex xs4 pl-2>
      <v-menu
        v-model="adjustment_date_menu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :disabled="disableFields"
            clearable
            v-model="adjustment_date_formated"
            mask="##/##/####"
            return-masked-value
            label="Data de reajuste"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
          no-title
          v-model="editedData.adjustment_date"
          @input="adjustment_date_menu = false"
        ></v-date-picker>
      </v-menu>
      <!-- <v-text-field
        v-model="editedData.adjustment_date"
        label="Data de reajuste"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>-->
    </v-flex>
    <v-flex xs4 pl-4>
      <v-text-field
        :disabled="disableFields"
        v-model="editedData.value"
        id="adjustmentValue"
        prefix="R$ "
        label="Valor"
        :rules="[]"
        v-money="$store.state.maskMoney.BRL"
      ></v-text-field>
    </v-flex>
    <v-flex xs4 pl-4 pr-2>
      <v-text-field
        :disabled="disableFields"
        v-model="editedData.adjustment_index"
        label="Índice de reajuste"

      ></v-text-field>
    </v-flex>
    <v-flex xs4 pl-2 pt-4>
      <v-text-field
        :disabled="disableFields"
        min="1"
        type="number"
        v-model="editedData.alert_date"
        :suffix="(formData.alert_date > 1) ? 'dias antes' : 'dia antes'"
        label="Avisar sobre vencimento"
        :rules="$store.state.formRules.required"
        required
      ></v-text-field>
    </v-flex>
    <v-flex xs4 pl-4 ml-4 pt-4>
      <v-checkbox
        :disabled="disableFields"
        v-model="editedData.thirteenth_charge"
        label="Cobrança de 13ª taxa"
        color="primary"
        hide-details
      ></v-checkbox>
    </v-flex>
  </v-layout>
</template>

<script>
// const defaulFinancialForm = {
//   adjustmentDate: "",
//   financialValue: "",
//   adjustmentIndex: "",
//   thirteenthCharge: "",
// };
import * as moment from 'moment'
import { VMoney } from 'v-money'

export default {
  name: 'FinancialForm',

  props: {
    disableFields: { type: Boolean, default: false },
    editedData: Object,
    loadFinancialForm: Function
  },

  data () {
    return {
      adjustment_date_menu: false
    }
  },

  directives: {
    money: VMoney
  },

  computed: {
    adjustment_date_formated: {
      get () {
        return this.editedData.adjustment_date
          ? moment(this.editedData.adjustment_date).format('DD/MM/YYYY')
          : ''
      },
      set (value) {
        if (value) {
          if (value.length < 10) return
          let arrs = value.split('/')
          let date = `${arrs[2]}-${arrs[1]}-${arrs[0]}`
          if (!moment(date).isValid()) {
            this.editedData.adjustment_date = new Date()
              .toISOString()
              .substr(0, 10)
            return
          }
          this.editedData.adjustment_date = date
        } else {
          this.editedData.adjustment_date = ''
        }
      }
    },

    formData () {
      return this.editedData
    }
  },

  methods: {
    updateFinancialForm () {
      this.$emit('getFinancialData', this.editedData)
    }
  }
}
</script>

<style>
</style>
